<template>
    <div id="account-dob">
      <f7-list form class="form-group">
        <f7-list-input
          input-id      ="dob"
          name          ="dob"
          type          ="text"
          :label        ="$t('regis-dob')"
          :placeholder  ="$t('regis-dob')"
          autocomplete  ="off"
          outline
          floating-label
          required
          :value        = "updateDetails.dob"
          @change       ="setUpdateDob($event.target.value);validateInput($event.target);validateNextButton()"
        ></f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {

    },
    mounted (){
      this.init()
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('customer', [
          'updateDetails'
      ])
    },
    methods: {
      ...mapActions('customer', [
          'setUpdateDob',
          'validateInput',
      ]),

      init(){
        const self = this;

        const initDob = self.updateDetails.dob.split("-").reverse().join("-");
        //console.log("initDob det: "+initDob);

        const moment= require('moment');
        const oldDob  = moment(new Date(initDob)).format('YYYY-MM-DD');
        const maxDate = moment().subtract(18, 'years').format('YYYY-MM-DD'); // MIN 18 y.o
        const maxYear = moment().subtract(18, 'years').year();
        const maxMonth = moment().subtract(18, 'years').month();

        let newDob = null;
        if(initDob == "01-01-1950" || initDob == "" /*|| initDob == #regDate */){
          newDob = null
        }else{
          console.log(oldDob+" ### "+maxDate)
          if(oldDob > maxDate /*&& oldDob != #regDate */){ // UNDERAGE ( < 18 y.o)
            newDob = oldDob;
          }else{
            if(oldDob /* != #regDate */){
              newDob = oldDob
            }else{
              newDob = null
            }
            
          }
        }

        //console.log("new new dob : "+newDob)

        self.accountDobCalendar = self.$f7.calendar.create({
          inputEl: '#dob',
          openIn: 'popup',
          dateFormat: "dd-mm-yyyy",
          closeOnSelect: true,
          value: newDob == null ? null : [new Date(newDob)],
          //maxDate: new Date(maxDate)
          yearPickerMax: maxYear,
          disabled: function (date) {
              if (date > new Date(maxDate)) {
                  return true;
              }
              else {
                  return false;
              }
          },
          on: {
            open: function () {
              //console.log('Calendar open : '+self.accountDobCalendar.getValue())
              if(self.accountDobCalendar.getValue() == undefined){
                self.accountDobCalendar.setYearMonth(maxYear, maxMonth)
              }
            }
          }
        })
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }

    }
  }
</script>